import { render } from "./CustomerWithOrdersListPage.vue?vue&type=template&id=b561b2a2&scoped=true"
import script from "./CustomerWithOrdersListPage.vue?vue&type=script&lang=js"
export * from "./CustomerWithOrdersListPage.vue?vue&type=script&lang=js"

import "./CustomerWithOrdersListPage.vue?vue&type=style&index=0&id=b561b2a2&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b561b2a2"]])

export default __exports__